import generalSection from "../_section/section.class";
import {userCVUpload, adminCVUpload} from "./upload";
import DataForm from "../credit-report/DataForm";


export class userCVSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userCVUpload);
        // Add missing date error

    }
}

export class adminCVSection extends userCVSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminCVUpload);
        this.DataForm = DataForm
        this.activeUpload = this.uploads.find(u => u.isActive)
        this.activeUploads = this.uploads.filter(upload => upload.isActive)
        this.sortByDateProp('documentDate');

        this.setProblems(this.problemsList.singleUploadUserProblems())
    }
    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags:[]
            }
        ]
    }
}